"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = void 0;
const lodash_1 = require("lodash");
const sessions_1 = require("../../../domain/sessions");
const BaseDataProvider_1 = require("./BaseDataProvider");
class SessionProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        super(...arguments);
        this.query = (options) => {
            let query = this.refs.sessions();
            query = (0, lodash_1.isNil)(options.userId) ? query : query.where('userId', '==', options.userId);
            query = (0, lodash_1.isNil)(options.app) ? query : query.where('app', '==', options.app);
            return query;
        };
    }
    createSession(sessionParams) {
        const doc = {
            ...sessionParams,
            createdAt: Date.now(),
        };
        return this.insertWithId(this.refs.sessions(), doc);
    }
    session(id) {
        return this.docPromise(this.refs.session(id));
    }
    sessionObs(id) {
        return this.docDataStream(this.refs.session(id), true);
    }
    allSessionsForUser(userId, app) {
        return this.find({ userId, app });
    }
    async clearOldForUser(userId, app, sessionLimit) {
        const current = await this.allSessionsForUser(userId, app);
        const toRemove = sessions_1.Session.toRemoveBasedOnLimit(current, sessionLimit);
        await Promise.all(toRemove.map((token) => {
            return this.refs.session(token._id).delete();
        }));
    }
    find(options) {
        return this.collectionPromise(this.query(options));
    }
}
exports.SessionProvider = SessionProvider;
//# sourceMappingURL=SessionProvider.js.map